import react, { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CommonPopup } from "../../util/common";
import { GET_SCORM_DATA } from "../../util/constants";
import { getNoCacheCall, postCall } from "../../util/resources";
import { scormTest } from "./scormTest";
import { scormTraining } from "./scormTraining";

const Scorm = () => {
    const [scormUrl, setScormUrl] = useState();
    const [iFrameShow, setiFrameShow] = useState(true);
    const [popupData, setpopupData] = useState({
        isOpen: false,
        popupHeader: "",
        popupBody: "",
        popupFooter: "",
    });
    const searchP = location.hash.replace("#/", "");
    const [searchParams, setSearchParams] = useSearchParams(searchP);

    const fieldSystem = useRef();

    const phrases = JSON.parse(sessionStorage.getItem("phrases"));
    const sessionDetails = JSON.parse(sessionStorage.getItem("session_data"));
    const testID = searchParams.get("testId");
    const instrumentType = searchParams.get("instrumentType");
    const isTraining = instrumentType === "3";

    const splitArray = (url) => {
        var splitUrl = url.split("/");
        var partOne = window.location.protocol + "//" + window.location.host;
        for (var i = 1; i < splitUrl.length - 1; i++) {
            partOne = partOne + "/" + splitUrl[i];
        }
        partOne = partOne + "/";
        var partTwo =
            window.location.protocol + "//" + window.location.host + url;
        return [partOne, partTwo];
    };

    const isCompatibleBrowser = () => {
        var isChrome =
            !!window.chrome &&
            (!!window.chrome.webstore || !!window.chrome.runtime);

        if (isChrome) {
            var raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);

            var version = raw ? parseInt(raw[2], 10) : false;

            if (version > 55 && fieldSystem.current == 36) {
                return true;
            }
        }

        return false;
    };

    const completeCalls = async (url, dataobject, isTraining) => {
        if (isTraining) {
            url = "scormtraining/" + url;
        } else {
            url = "scorm/" + url;
        }
        const response = await postCall("/rest/" + url, dataobject, {
            "x-xpert-session": dataobject.assignmentId,
            "X-Requested-With": "XMLHttpRequest",
        });
        return response.data;
    };

    const asyncScorm = (url, dataobject, isTraining) => {
        if (isTraining) {
            url = "scormtraining/" + url;
        } else {
            url = "scorm/" + url;
        }
        try {
            const request = new XMLHttpRequest();
            request.open("POST", "/rest/" + url, false);
            request.setRequestHeader(
                "x-xpert-session",
                JSON.stringify(dataobject.assignmentId)
            );
            request.setRequestHeader("X-Requested-With", "XMLHttpRequest");
            request.setRequestHeader("Content-Type", "application/json");
            request.send(JSON.stringify(dataobject));
            if (request.status === 200) {
                return JSON.parse(request.responseText);
            }
            // const response = await postCall("/rest/" + url, dataobject, {
            //     "x-xpert-session": dataobject.assignmentId,
            //     "X-Requested-With": "XMLHttpRequest",
            // });
            // return response.data;
            // return (async () => {
            //     await postCall("/rest/" + url, dataobject, {
            //         "x-xpert-session": dataobject.assignmentId,
            //         "X-Requested-With": "XMLHttpRequest",
            //     }).then((response) => {
            //       console.log(response);
            //       return response.data;
            //     });
            //   })();
        } catch (error) {
            return error;
        }
    };

    const getScormData = async () => {
        try {
            const response = await getNoCacheCall(
                GET_SCORM_DATA + testID + "/" + instrumentType,
                {
                    "X-Xpert-Session": sessionDetails.sessionId,
                }
            );
            if (response.data) {
                fieldSystem.current = response.data.fieldSystem.toString();
                let API_XPERT = isTraining
                    ? scormTraining(
                          phrases,
                          sessionDetails.sessionId,
                          testID,
                          fieldSystem.current,
                          isCompatibleBrowser,
                          asyncScorm,
                          setiFrameShow,
                          closeRTE,
                          closeRTEAsync,
                          completeCalls
                      )
                    : scormTest(
                          phrases,
                          sessionDetails.sessionId,
                          testID,
                          isCompatibleBrowser,
                          asyncScorm,
                          setiFrameShow,
                          closeRTE,
                          closeRTEAsync,
                          completeCalls
                      );
                window["API"] = API_XPERT;
                if (response.data.url) {
                    setScormUrl(splitArray(response.data.url));
                } else {
                    setpopupData((prev) => {
                        prev = {
                            ...prev,
                            isOpen: true,
                            popupBody: phrases?.["1002044"],
                            popupFooter: phrases?.["10928"],
                        };
                        return prev;
                    });
                }
            } else {
                setpopupData((prev) => {
                    prev = {
                        ...prev,
                        isOpen: true,
                        popupBody: phrases?.["1002044"],
                        popupFooter: phrases?.["10928"],
                    };
                    return prev;
                });
            }
        } catch (error) {
            console.error(error, "error trying to recover third party test;");
            setpopupData((prev) => {
                prev = {
                    ...prev,
                    isOpen: true,
                    popupBody: phrases?.["1002044"],
                    popupFooter: phrases?.["10928"],
                };
                return prev;
            });
        }
    };

    /* jshint ignore:start */
    async function closeRTEAsync(exitSCO, statusSCO, RequestObject) {
        let ret = "";
        if (
            exitSCO != "logout" &&
            (statusSCO == "passed" ||
                statusSCO == "completed" ||
                statusSCO == "failed")
        ) {
            let response = await postCall(
                "/rest/scormtraining/nextURLSCO",
                RequestObject,
                {
                    "x-xpert-session": dataobject.assignmentId,
                    "X-Requested-With": "XMLHttpRequest",
                }
            );

            let respjson = response.data;

            if (respjson != null) {
                ret = respjson.scormValue;
            }
        }

        if (ret == "") {
            if (window.opener) {
                window.opener.location.reload(true);
                window.close();
            }
        } else {
            setiFrameShow(true);
            setScormUrl(splitArray(ret));
        }
    }
    /* jshint ignore:end */

    const closeRTE = async (exitSCO, statusSCO, RequestObject) => {
        let ret = "";
        if (
            exitSCO != "logout" &&
            (statusSCO == "passed" ||
                statusSCO == "completed" ||
                statusSCO == "failed")
        ) {
            let response = await completeCalls("nextURLSCO", RequestObject, true);

            ret = response.scormValue;
        }
        if (ret == "") {
            if (window.opener) {
                window.opener.location.reload(true);
                window.close();
            }
        } else {
            setiFrameShow(true);
            setScormUrl(splitArray(ret));
        }
    };

    const closePopUp = () => {
        setpopupData((prev) => {
            prev = { ...prev, isOpen: false };
            return prev;
        });
    };

    useEffect(() => {
        getScormData();
    }, []);

    return (
        <>
            <CommonPopup
                popupData={popupData}
                closeAction={closePopUp}
                setterFun={setpopupData}
            />
            {iFrameShow && scormUrl && (
                <iframe
                    src={scormUrl[1]}
                    cp-resizable="true"
                    frameBorder="0"
                    width="100%"
                    id="scormFrameId"
                    name="scormFrameName"
                    style={{ height: "98vh" }}
                />
            )}
        </>
    );
};

export default Scorm;
